module.exports = __webpack_public_path__ + "img/17_48.69d8cc22.png";